import React from "react";

const KBSectionLinks = ({ sections, category, subcategory }) => {
  if (!sections || sections.length === 0) {
    return null;
  }
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(`section-${sectionId}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <div className="kb-section-links">
      <h6 className="mb-2">Jump to:</h6>
      <div className="section-links-container">
        {sections.map((section, index) => (
          <React.Fragment key={section.id}>
            <a 
              href={`#${category}-${subcategory}-section-${section.id}`}
              className="section-link"
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(section.id);
              }}
            >
              {section.title}
            </a>
            {index < sections.length - 1 && <span className="section-divider">|</span>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default KBSectionLinks;